<div class="dashboard">
  <div class="dashboard-header" *ngIf="!isFullScreen">
    <div class="dashboard-logo">
      <img src="./assets/img/logo-white.png" />
    </div>

    <div ngbDropdown container="body">
      <div class="user-title" ngbDropdownToggle>
        <!-- <div class="user-title" ngbDropdownToggle [class.disabled]="isLoading"> -->
        <div class="circle">{{ userInitials }}</div>
        <div class="dropdown-icon">
          <i class="fas fa-chevron-down"></i>
        </div>
        <div class="padding-top" ngbDropdownMenu>
          <div class="dropdown-menu-inside">
            <button ngbDropdownItem (click)="editProfile()">
              Profile Info
            </button>
            <button ngbDropdownItem (click)="changeUserPassword()">
              Change password
            </button>
            <button ngbDropdownItem (click)="logout()">Logout</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="dashboard-page">
    <div class="dashboard-menu" *ngIf="!isFullScreen">
      <app-sidebar></app-sidebar>
    </div>
    <div class="dashboard-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
